import React, { Fragment, useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel,
    Button,
    Paper,
    Box,
    InputLabel,
    Select,
    Story,
    MenuItem

} from '@material-ui/core';

import { useStyles } from '../../styles/style';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { onPostPage } from './../../Redux/Actions/pageAction';
import { StoreMallDirectory } from '@material-ui/icons';
import axios from 'axios';
import cogoToast from 'cogo-toast';
import { Link ,useHistory} from 'react-router-dom';
import StoreModal from './../Reusable/stores.json';
import Switch from "react-switch";
import CancelIcon from '@material-ui/icons/Cancel';

export default function EditPage(props) {
    const classes = useStyles();
    const [code, setCode] = useState("");
    const [deepLink, setDeepLink] = useState("");
    const [addId, setAddId] = useState("");
    const [iname, setName] = useState("");
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [enable, setEnable] = useState("true");
    const [hindiLang, setHindiLang] = useState("");
    const [marathiLang, setMarathiiLang] = useState("");
    const [kannadaLang, setKannadaLang] = useState("");
    const [teluguLang, setTeluguLang] = useState("");
    const [punjabiLang, setPunjabiLang] = useState("");
    const [tamilLang, setTamilLang] = useState("");
    const [gujaratiLang, setGujaratiLang] = useState("");
    const [modal, setModal] = useState(false);
    const [hindiSubTitle, setHindiSubTitle] = useState("");
    const [marathiSubTitle, setMarathiiSubTitle] = useState("");
    const [kannadaSubTitle, setKannadaSubTitle] = useState("");
    const [teluguSubTitle, setTeluguSubTitle] = useState("");
    const [punjabiSubTitle, setPunjabiSubTitle] = useState("");
    const [tamilSubTitle, setTamilSubTitle] = useState("");
    const [gujaratiSubTitle, setGujaratiSubTitle] = useState("");
    const [submodal, setSubModal] = useState(false);
    const [stories, setStories] = useState([]);
    const [app, setApp] = useState([]);
    const [appId, setAppId] = useState("");
    const [storeId,setStoreId] = useState("")
    const [v0, setv0] = useState([]);
    const [v2, setv2] = useState([]);
    const [delete_v0, setDeletev0] = useState([]);
    const [delete_v2, setDeletev2] = useState([]);
    const [continueToggle, setcontinueToggle] = useState(false)
    const navigate = useHistory(); 
    const toggle = () => setModal(!modal);

    const subToggle = () => {
        setSubModal(!submodal);
    }

    const handlev0 = (e) => {
        setv0([...v0, ...e.target.files])
    }

    const deletev0 = (e, i,ele) => {
        let newArray = v0.filter((ele, index) => {
            return index !== i;
        })
        setDeletev0([...delete_v0, ele]);
        setv0(newArray)
    }
    const handlev2 = (e) => {
        setv2([...v2, ...e.target.files])
    }

    const deletev2 = (e, i,ele) => {
        let newArray = v2.filter((ele, index) => {
            return index !== i;
        })
        setDeletev2([...delete_v2, ele]);
        setv2(newArray)
    }
    const handleChangeToggle = (e) =>{
        console.log('ee',e)
        setcontinueToggle(e)
    }

    const fetchPagebyId = () => {
        let data = localStorage.getItem("storeId");
        if(data){
         setStoreId(localStorage.getItem("storeId"));
        axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/${props.match.params.id}?storeId=${data}`)
            .then(res => {
                console.log(res)
                setTitle(res.data.result.result.title.en)
                setHindiLang(res.data.result.result.title.hn)
                setMarathiiLang(res.data.result.result.title.mr)
                setGujaratiLang(res.data.result.result.title.gu_in)
                setKannadaLang(res.data.result.result.title.kn_in)
                setTeluguLang(res.data.result.result.title.te_in)
                setTamilLang(res.data.result.result.title.ta_in)
                setPunjabiLang(res.data.result.result.title.pa_in)
                setSubTitle(res.data.result.result.subTitle.en)
                setHindiSubTitle(res.data.result.result.subTitle.hn)
                setMarathiiSubTitle(res.data.result.result.subTitle.mr)
                setGujaratiSubTitle(res.data.result.result.subTitle.gu_in)
                setKannadaSubTitle(res.data.result.result.subTitle.kn_in)
                setTeluguSubTitle(res.data.result.result.subTitle.te_in)
                setTamilSubTitle(res.data.result.result.subTitle.ta_in)
                setPunjabiSubTitle(res.data.result.result.subTitle.pa_in)
                setEnable(res.data.result.result.enabled.toString())
                setAppId(res.data.result.result.appId)
                setCode(res.data.result.result.pageCode)
                setName(res.data.result.result.iname ? res.data.result.result.iname : '')
                setDeepLink(res.data.result.result.deepLink ? res.data.result.result.deepLink : '')
                setAddId(res.data.result.result.addId ? res.data.result.result.addId : '')
                setv0(res.data.result.result.media ? res.data.result.result.media :[])
                setv2(res.data.result.result.thumbnail ? res.data.result.result.thumbnail:[])
                setcontinueToggle(str2bool(res.data.result.result.isBrandHub ? res.data.result.result.isBrandHub : false))
                console.log('v0',v0)
            }).catch(err => {
                console.log(err)
            })
        }
        else{
         navigate.push('/login');
        }
    }

    useEffect(() => {
        fetchPagebyId()
    }, [])

    const fetchApp = () => {
        let data = localStorage.getItem("storeId");
        if(data){
         setStoreId(localStorage.getItem("storeId"));
        axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/type/app?storeId=${data}`)
            .then(res => {
                setApp(res.data.result.result)
            }).catch(err => {
                console.log(err)
            })
        }
        else{
         navigate.push('/login');
        }
            
    }

    useEffect(() => {
        fetchApp()
    }, [])


    const enhandleChange = (event) => {
        setEnable(event.target.value);

    };

    const onPostpage = async (data) => {
        const fd = new FormData()
        fd.append("type", data.type);
        fd.append("pageCode",data.pageCode);
        fd.append("enabled", data.enabled);
        fd.append("title", JSON.stringify(data.title));
        fd.append("subTitle", JSON.stringify(data.subTitle));
        fd.append("appId", data.appId);
        fd.append("storeId", data.storeId);
        fd.append("iname", data.iname);
        fd.append("isBrandHub",data.isBrandHub);
        fd.append("deepLink", data.deepLink);
        fd.append("addId", data.addId);
        for (let index = 0; index < data.file.length; index++) {
            const element = data.file[index];
            if (typeof (element) !== "string") {
            fd.append('file', element)
            }
        }
        data.delete_v0.map((ele, i) => {
            fd.append(`deleteMedia[${i}]`, ele)
        })
        for (let index = 0; index < data.thumbnail.length; index++) {
            const element = data.thumbnail[index];
            if (typeof (element) !== "string") {
            fd.append('thumbnail', element)
            }
        }
        data.delete_v2.map((ele, i) => {
            fd.append(`deleteThumbnail[${i}]`, ele)
        })
        await axios.put(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/page/${props.match.params.id}`, fd)
            .then(
                res => {
                    if (res.status == 200) {
                        cogoToast.success(res.data.result.message);
                        props.history.push('/listPage')

                    }
                }
            ).catch(err => {
                cogoToast.success("somthing went wrong!");
            })
    }

    var str2bool = (value) => {
        if (value && typeof value === "string") {
            if (value.toLowerCase() === "true") return true;
            if (value.toLowerCase() === "false") return false;
        }
        return value;
    } 



    const onSubmit = () => {
        const obj = {
            "type": "page",
            "pageCode": code,
            "enabled":str2bool(enable),
            "title": {
                "hn": hindiLang,
                "mr": marathiLang,
                "en": title,
                "kn_in": kannadaLang,
                "te_in": teluguLang,
                "pa_in": punjabiLang,
                "ta_in": tamilLang,
                "gu_in": gujaratiLang
            },
            "subTitle": {
                "hn": hindiSubTitle,
                "mr": marathiSubTitle,
                "en": subTitle,
                "kn_in": kannadaSubTitle,
                "te_in": teluguSubTitle,
                "pa_in": punjabiSubTitle,
                "ta_in": tamilSubTitle,
                "gu_in": gujaratiSubTitle
            },
            "appId": appId,
            "storeId":localStorage.getItem("storeId"),
            "iname":iname,
            "file": v0,
            "thumbnail":v2,
            "isBrandHub":str2bool(continueToggle),
            "deepLink": deepLink,
            "addId":addId,
            "delete_v0": delete_v0,
            "delete_v2": delete_v2
        }
        console.log(obj)
        onPostpage(obj)
    }

    const onClear = () => {
        setCode("");
        setTitle("");
        setSubTitle("");
        setAppId("")
    }


    return (
        <Fragment>
            <Paper component={Box} p={4}>
                <div className="text-center">
                    <h1>Edit Pages</h1>
                    <Grid container className="text-center">
                        <Grid item md={6}>
                            <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: "60%" }}>
                                <InputLabel id="demo-simple-select-outlined-label">Apps</InputLabel>

                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={appId}
                                    onChange={(e) => setAppId(e.target.value)}
                                    label="Pages"
                                >
                                    {
                                        app && app.length > 0 ?
                                            app.map((element, id) => {

                                                return (
                                                    <MenuItem key={id} value={element._id}>{element.title}</MenuItem>
                                                )
                                            }) :
                                            <MenuItem disabled value="no pages">No app</MenuItem>

                                    }

                                </Select>

                            </FormControl>

                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Identifire Name" name="iname" value={iname} onChange={e => setName(e.target.value)} ></TextField>
                        </Grid>
                        {/* <Grid item xs={4}>
                    <FormControl variant="outlined" className={classes.formControl} >
                            <InputLabel id="demo-simple-select-outlined-label">Stores</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={storeId}
                                onChange={(e) => setStoreId(e.target.value)}
                                label="Stores"
                            >
                                {
                                    StoreModal && StoreModal.length > 0 ?
                                        StoreModal.map((element, id) => {
                                            return (
                                                <MenuItem key={id} value={element.storeId}><img src={element.image}/>&nbsp;{element.description}</MenuItem>
                                            )
                                        }) :
                                        <MenuItem disabled value="no pages">No Stores Available</MenuItem>
                                }

                            </Select>

                        </FormControl>
                        </Grid> */}
                    </Grid>
                    <Grid container >
                        {/* <Grid item md={9} sm={12} >
                            


                        </Grid> */}

                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Code" name="code" value={code} onChange={e => setCode(e.target.value)} ></TextField>
                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputFieldBucket} width="25" required label="Title" name="title" value={title} onChange={e => setTitle(e.target.value)} >
                            </TextField>
                            <Button style={{ height: "56px" }} variant="contained" onClick={toggle}>Multi-Language</Button>
                        </Grid>
                        
                        <Grid item md={6} sm={12}>
                            <FormControl className={classes.formControl}>
                                <FormLabel className={classes.lables} component="div" >Enabled</FormLabel>
                                <RadioGroup aria-label="enable" name="enable" value={enable} onChange={enhandleChange} row>

                                    <FormControlLabel value="true" control={<Radio />} label="true" />
                                    <FormControlLabel value="false" control={<Radio />} label="false" />

                                </RadioGroup>
                            </FormControl>

                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputFieldBucket} width="25" required label="Sub-Title" name="subTitle" value={subTitle} onChange={e => setSubTitle(e.target.value)} >
                            </TextField>
                            <Button style={{ height: "56px" }} variant="contained" onClick={subToggle}>Multi-Language</Button>

                        </Grid>
                        <Grid item md={6} sm={12}>
            Is BrandHub :&nbsp;<Switch 
            onChange={handleChangeToggle} value={continueToggle} checked={continueToggle}
             />
                </Grid>
                <Grid style={continueToggle == true ? { visibility: "visible" } : { visibility: "hidden" }} item md={6} sm={12}>
                            <Button
                                className={classes.upload}
                                variant="outlined"
                                component="label"
                            >
                                Banners
                                <input
                                    multiple
                                    type="file"
                                    hidden
                                    onChange={handlev0}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                />
                            </Button>
                            {v0.length > 0 ?
                                (v0.map((ele, i) => <div><p className="mt-2 mr-4" onClick={() => window.open(ele.name ? null : `https://storage.googleapis.com/media-content-hungama-com/page/${ele}`, "_blank")} style={{ cursor: "pointer", display: "inline" }}>{ele.name ? ele.name : ele}</p><CancelIcon onClick={(e) => deletev0(e, i, ele)} /></div>))
                                : null}

                        </Grid>
                        <Grid style={continueToggle == true ? { visibility: "visible" } : { visibility: "hidden" }} item md={6} sm={12}>
                            <Button
                                className={classes.upload}
                                variant="outlined"
                                component="label"
                            >
                                Heading
                                <input
                                    multiple
                                    type="file"
                                    hidden
                                    onChange={handlev2}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                />
                            </Button>
                            {v2.length > 0 ?
                                (v2.map((ele, i) => <div><p className="mt-2 mr-4" onClick={() => window.open(ele.name ? null : `https://storage.googleapis.com/media-content-hungama-com/page/${ele}`, "_blank")} style={{ cursor: "pointer", display: "inline" }}>{ele.name ? ele.name : ele}</p><CancelIcon onClick={(e) => deletev2(e, i, ele)} /></div>))
                                : null}

                        </Grid>
                <Grid style={continueToggle == true ? { visibility: "visible" } : { visibility: "hidden" }} item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Deep Link" name="deepLink" value={deepLink} onChange={e => setDeepLink(e.target.value)} ></TextField>
                        </Grid>
                        <Grid style={continueToggle == true ? { visibility: "visible" } : { visibility: "hidden" }} item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="AddId" name="addId" value={addId} onChange={e => setAddId(e.target.value)} ></TextField>
                        </Grid>
                        <Grid item md={12}>
                            <Button className="m-4" variant="contained" color="primary" onClick={onSubmit}>Update</Button>
                            <Button variant="contained" color="secondary" onClick={onClear}>Clear</Button>

                        </Grid>
                    </Grid>

                    {/* Title Modal */}
                    <Modal style={{ marginTop: "100px" }} isOpen={modal} toggle={toggle}>
                        <ModalHeader toggle={toggle}>MultiLanguage Title</ModalHeader>
                        <ModalBody>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="English" name="name" value={title} onChange={e => setTitle(e.target.value)}>
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Hindi" name="name" value={hindiLang} onChange={e => setHindiLang(e.target.value)}>
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Marathi" name="name" value={marathiLang} onChange={e => setMarathiiLang(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Kannada" name="name" value={kannadaLang} onChange={e => setKannadaLang(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Telugu" name="name" value={teluguLang} onChange={e => setTeluguLang(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Punjabi" name="name" value={punjabiLang} onChange={e => setPunjabiLang(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Tamil" name="name" value={tamilLang} onChange={e => setTamilLang(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Gujrati" name="name" value={gujaratiLang} onChange={e => setGujaratiLang(e.target.value)} >
                            </TextField>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggle}>Save</Button>{' '}
                            <Button color="secondary" onClick={toggle}>Cancel</Button>
                        </ModalFooter>
                    </Modal>

                    {/* Sub-Title Modal */}
                    <Modal style={{ marginTop: "100px" }} isOpen={submodal} toggle={subToggle}>
                        <ModalHeader toggle={subToggle}>MultiLanguage SubTitle</ModalHeader>
                        <ModalBody>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="English" name="subtitle" value={subTitle} onChange={e => setSubTitle(e.target.value)}>
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Hindi" value={hindiSubTitle} onChange={e => setHindiSubTitle(e.target.value)}>
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Marathi" value={marathiSubTitle} onChange={e => setMarathiiSubTitle(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Kannada" value={kannadaSubTitle} onChange={e => setKannadaSubTitle(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Telugu" value={teluguSubTitle} onChange={e => setTeluguSubTitle(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Punjabi" value={punjabiSubTitle} onChange={e => setPunjabiSubTitle(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Tamil" value={tamilSubTitle} onChange={e => setTamilSubTitle(e.target.value)} >
                            </TextField>
                            <TextField className="mt-2" variant="outlined" fullWidth width="25" required label="Gujrati" value={gujaratiSubTitle} onChange={e => setGujaratiSubTitle(e.target.value)} >
                            </TextField>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={subToggle}>Save</Button>{' '}
                            <Button color="secondary" onClick={subToggle}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </Paper>
        </Fragment>
    )
}
